export const SERVER_URL = 'https://api.tinytingel.ai/api/v2/admin';
// export const SERVER_URL = 'http://localhost:4000/api/v2/admin';
